import { Component, OnInit, forwardRef } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  NavController,
  NavParams,
  ModalController,
  LoadingController,
  ToastController,
  AlertController,
  IonicModule,
} from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormGeradorPage } from 'src/app/pages/form-gerador/form-gerador.page';
import { BuscarPessoaPage } from '../../buscar-pessoa/buscar-pessoa.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { UserProvider } from 'src/app/services/user/user';
import { CommonModule } from '@angular/common';

import { ImagePipe } from 'src/app/pipes/image/image';
import { InstituicaoProvider } from 'src/app/services/instituicao/instituicao';

@Component({
  selector: 'app-grupo-gerenciar-participantes-add',
  templateUrl: './grupo-gerenciar-participantes-add.page.html',
  styleUrls: ['./grupo-gerenciar-participantes-add.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    ReactiveFormsModule,
  ],
})
export class GrupoGerenciarParticipantesAddPage implements OnInit {
  pessoa: any = {};
  grupoCargos: any = [];
  idGrupo: any;
  participantes: any = [];
  loader = this.loadingController.create({
    message: this.translate.instant('Carregando'),
  });
  tipo;
  participante: any = {};
  validations_form: FormGroup;
  exibirFiltroMembrosTodasFiliais = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public formBuilder: FormBuilder,
    public grupoProvider: GrupoProvider,
    public loadingController: LoadingController,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    public userProvider: UserProvider,
    public alertCtrl: AlertController,
    public instituicaoProvider: InstituicaoProvider
  ) {
    this.tipo = this.navParams.get('tipo');
    this.participante = this.navParams.get('participante');

    if (this.participante && this.participante.id) {
      this.pessoa = {
        id: this.participante.id,
        nome: this.participante.nome,
        foto: this.participante.foto,
      };

      this.validations_form = this.formBuilder.group({
        idGrupoCargo: new FormControl(this.participante.idGrupoCargo),
        permissaoPortal: new FormControl(
          this.participante.permissaoPortal == '1'
        ),
      });
    } else {
      this.validations_form = this.formBuilder.group({
        idGrupoCargo: new FormControl('0'),
        permissaoPortal: new FormControl(false),
      });
    }

    this.idGrupo = navParams.get('idGrupo');

    this.grupoProvider.getGrupoCargoNovo(this.tipo).subscribe((data) => {
      this.grupoCargos = data;
    });

    if (this.navParams.get('solicitacaoParticipante')) {
      this.validacao(this.navParams.get('solicitacaoParticipante'));
    }

    this.instituicaoProvider.hasConfigSede('218').subscribe((data) => {
      this.exibirFiltroMembrosTodasFiliais = data;
    });
  }

  ngOnInit() {}

  public async selecionarPessoa(): Promise<any> {
    const dataPessoa = {
      isVisitante: false,
      adiciona: true,
      exibirFiltroMembrosTodasFiliais: this.exibirFiltroMembrosTodasFiliais,
    };

    const modalPessoa = await this.modalCtrl.create({
      component: BuscarPessoaPage,
      componentProps: dataPessoa,
    });
    modalPessoa.present();
    const pessoa = await modalPessoa.onWillDismiss();
    if (pessoa.data) {
      this.validacao(pessoa.data);
    } else if (pessoa.data == false) {
      return '';
    }
  }

  async validacao(dados: any) {
    this.pessoa = dados.pessoa ? dados.pessoa : dados;
    const participante = { idPessoa: this.pessoa.id };

    if (this.userProvider.hasConfig(48) || this.userProvider.hasConfig(191)) {
      this.grupoProvider
        .checkGrupo(this.pessoa.id, this.idGrupo)
        .subscribe(async (data) => {
          if (data) {
            let alertMessage = `${this.pessoa.nome} participa de outro Grupo ou Célula. Deseja adicioná-lo mesmo assim?`;
            let buttons: any[] = [
              {
                text: this.translate.instant('Não'),
                role: 'cancel',
                handler: () => {
                  this.clear()
                },
              },
            ];

            if (this.userProvider.hasConfig(191)) {
              alertMessage = `${this.pessoa.nome} já participa de outro Grupo ou Célula.`;
              buttons[0].text = this.translate.instant('Fechar');
            } else {
              buttons.push({
                text: this.translate.instant('Sim'),
                handler: () => {
                  this.criar(participante, false);
                },
              });
            }

            const alert = await this.alertCtrl.create({
              cssClass: "alerta-personalizado",
              mode: "ios",
              header: this.translate.instant('Atenção'),
              message: alertMessage,
              buttons: buttons,
            });

            await alert.present();
          } else {
            this.criar(participante, false);
          }
        });
    } else {
      this.criar(participante, false);
    }
  }

  clear() {
    this.pessoa = {};

    if (this.participante && this.participante.id) {
      this.pessoa = {
        id: this.participante.id,
        nome: this.participante.nome,
        foto: this.participante.foto,
      };
    }
  }

  criarParticipante() {
    this.userProvider.getDados().then(async (result) => {
      var cadastro: any = {};
      cadastro.form = 'APP_GRU_MEMBRO';
      cadastro.idPessoaTipo = 1;
      cadastro.titulo = this.translate.instant('Adicionar Participante');
      cadastro.idInstituicao = result.instituicao.id;

      const modalPessoa = await this.modalCtrl.create({
        component: FormGeradorPage,
        componentProps: cadastro,
      });
      modalPessoa.present();

      const pessoa = await modalPessoa.onWillDismiss();

      if (pessoa.data) {
        this.pessoa = pessoa.data;
        let participante = { idPessoa: this.pessoa.id };
        this.criar(participante, false);
      }
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss(false);
  }

  onSubmit(participante: { permissaoPortal: string; idPessoa: any }) {
    participante.permissaoPortal = participante.permissaoPortal ? '1' : '0';
    participante.idPessoa = this.pessoa.id;
    this.criar(participante, true);
  }

  public criar(participante: { idPessoa: any }, back = true) {
    this.grupoProvider
      .criarParticipante(this.idGrupo, participante)
      .subscribe(async (data) => {
        if (data.status !== false) {
          this.grupoProvider
            .getParticipantesGrupo(this.idGrupo)
            .subscribe(async (d) => {
              this.participantes = d;
              if (back) {
                const toast = await this.toastCtrl.create({
                  message: this.translate.instant(
                    'Participante salvo com sucesso!'
                  ),
                  duration: 3000,
                });

                toast.present();
                this.modalCtrl.dismiss(this.participantes);
              }
            });
        } else {
          let confirmAlert = await this.alertCtrl.create({
            cssClass: "alerta-personalizado",
            mode: "ios",
            header: this.translate.instant('Atenção'),
            message: this.translate.instant(data.message),
            buttons: [
              {
                text: this.translate.instant('Ok'),
                role: 'cancel',
              },
            ],
          });
          confirmAlert.present();
        }
      });
  }
}
